var AT_Main = {
	/*New Func add top content page FAQ*/
	initFAQ: function() {
		if(!$('.s4com-helpcenter').length)	
			return;
		$('body').addClass('faq');
		var breadcrumbs = '<div class="breadcrumbs-v2 cata-header faq-breadcrumb margin-bottom-20">\
						        <div class="collection-description-wrapper">\
						        	<div class="collection-heading">\
						        		<h1 class="catalog-title">Frequently Asked Questions</h1>\
						        	</div>\
						        </div>\
						    </div>';
		
		var container = $('<div class="container"></div>');
		container.append($('.s4com-helpcenter > .s4com-space-bottom'));
		$('.s4com-helpcenter').prepend(container);
		$('.s4com-helpcenter').prepend(breadcrumbs);
	},
	/*New Func change background image on page 404*/
	initBackStretch: function(){
		if(!$('.template404').length && !$('.templatePassword').length)
			return;
		$.backstretch([
	      "//bellamipro.myshopify.com/cdn/shop/t/54/assets/bkg-404.jpg?v=124710064412680030571671034660",
	      "//bellamipro.myshopify.com/cdn/shop/t/54/assets/bkg-404-2.jpg?v=50330599250113651821671034665"
	      ], {
	        fade: 1000,
	        duration: 7000
	    });

	},

	/*New Func Progress bar on About us page*/
	initProgressBarVertical: function () {
		if(!$('.progress').length)
    		return;
        jQuery('.progress').each(function () {
	        jQuery(this).appear(function() {
	          	jQuery(this).animate({opacity:1,left:"0px"},800);
	          	var b = jQuery(this).find(".progress-bar").attr("data-height");
	          	jQuery(this).find(".progress-bar").animate({
	            	height: b + "%"
	          	}, 100, "linear");
	        }); 
	    });  
    },

	/*New Func Init Counter on About us page*/
    initCounter: function () {
    	if(!$('.counter').length)
    		return;
        jQuery('.counter').counterUp({
            delay: 10,
            time: 1000
        });
    },

	/*New Func Set Background of Catalog Header*/
	setBkgHeaderCatalog : function() {
		if( !$('.cata-header img').length )	
			return;
		var imgURL = $('.cata-header img').attr('src');
		$('.cata-header').css({
			'background': 'url(' + imgURL + ') no-repeat center center',
		})
	},

	/*New Func Add Hover Effect of Newsletter Popup*/
	newsletterHoverEffect: function() {
		var newsletterWrap = $('#mailchimp-popup').parents('.fancybox-wrap');
		var newsletterOverlay = $('#mailchimp-popup').parents('.fancybox-overlay');
		var centerPoint = [$(window).width()/2, $(window).height()/2];
		const deg = 8;
		newsletterOverlay.addClass('area3d');
		newsletterOverlay.on('mousemove.effect3d', function(evt) {
			var rotY = (evt.clientX - centerPoint[0]) * deg / centerPoint[0];
			var rotX = (evt.clientY - centerPoint[1]) * deg / centerPoint[1];
			newsletterWrap.css({
				'transform': 'rotateY(' + -rotY + 'deg) ' + 'rotateX(' + rotX + 'deg)',	 	
				'-webkit-transform': 'rotateY(' + -rotY + 'deg) ' + 'rotateX(' + rotX + 'deg)',	 	
				'-moz-transform': 'rotateY(' + -rotY + 'deg) ' + 'rotateX(' + rotX + 'deg)',	 	
				'-o-transform': 'rotateY(' + -rotY + 'deg) ' + 'rotateX(' + rotX + 'deg)'	
			});
		});
	},

	/*New Func Remove Hover Effect of Newsletter Popup*/
	newsletterHoverEffectClear: function() {
		var newsletterOverlay = $('#mailchimp-popup').parents('.fancybox-overlay');
		newsletterOverlay.off( 'mousemove.effect3d' );	
	},
	
	getWidthBrowser : function() { // Get width browser
		var myWidth;

		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE 
			myWidth = window.innerWidth;
		} 
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
			//IE 6+ in 'standards compliant mode' 
			myWidth = document.documentElement.clientWidth; 
		} 
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
			//IE 4 compatible 
			myWidth = document.body.clientWidth;  
		}

		return myWidth;
	}
	
	,checkLayout : function() { // Function to check level of layout
		if(jQuery("#checkLayout .visible-xs-block").css("display") == "block")
			return 1; //mobile layout
		else if(jQuery("#checkLayout .visible-sm-block").css("display") == "block")
			return 2; //tablet potrait layout
		else if(jQuery("#checkLayout .visible-md-block").css("display") == "block")
			return 3; //tablet landscape/medium desktop layout
		else if(jQuery("#checkLayout .visible-lg-block").css("display") == "block")
			return 4; //desktop layout
	}
  
  	,previewPanel : function() {
        jQuery('#style-panel .style-toggle').on("click", function(e){
          jQuery(this).parents().find('#style-panel').toggleClass('open');
        });

        var currentLayoutMode;
		if( jQuery.cookie('bc_save_layout') ){
			var savedLayoutMode = jQuery.cookie('bc_save_layout');
			var _htmlLayoutMode = jQuery('.update-layout.selected').data('layout-mode');
			if( _htmlLayoutMode != savedLayoutMode ){
	            $('.update-layout').removeClass('selected');
	            $('.update-layout.'+savedLayoutMode).addClass('selected');
	            $('#page-body').removeClass(_htmlLayoutMode);
	            $('#page-body').addClass(savedLayoutMode);
	            $('body').removeClass(_htmlLayoutMode);
	            $('body').addClass(savedLayoutMode);
	            $(window).trigger('resize'); 
	            window.dispatchEvent(new Event('resize'));
			}
		}

        jQuery('.update-layout').on("click", function(e){
          currentLayoutMode = jQuery('.update-layout.selected').data('layout-mode');
          if(!jQuery(this).hasClass('selected')){
            $('.update-layout').removeClass('selected');
            $(this).addClass('selected');
            selectedLayout = $(this).data('layout-mode');
            $('#page-body').removeClass(currentLayoutMode);
            $('#page-body').addClass(selectedLayout);
            $('body').removeClass(currentLayoutMode);
            $('body').addClass(selectedLayout);            
            $(window).trigger('resize'); 
            window.dispatchEvent(new Event('resize'));
            jQuery.cookie('bc_save_layout', selectedLayout , { expires: 7, path: '/' });
          }
        });
    }
	
	,homeSlideshow : function(){
        if(jQuery('.home-slideshow-wrapper').length){
          	var check = false;
  			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if(check) 
              $('.home-slideshow-wrapper').addClass('mobile');
          	jQuery('.home-slideshow-wrapper').each(function(index,value){
                var swiper = new Swiper('.swiper-container', {
                    pagination: '.swiper-pagination'
                  	,loop: true
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 0
                    ,autoplay:10000
                    ,scrollbarDraggable: true
                    ,effect: jQuery(value).data('animation')
                  	,setWrapperSize: false
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();                        
                        });
                    }
                });
            });
        }
    }
  
  	,homeIE : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){
                var swiper = new Swiper('.swiper-container', {
                    pagination: '.swiper-pagination'
                  	,loop: true
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 0
                    ,scrollbarDraggable: true
                    ,effect: 'fade'
                  	,setWrapperSize: true
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          
                          
                        });
                    }
                });
            });
        }
    }
	
	,stickMenu : function() {
		var enable_stick = jQuery(".header-content").data('stick');
		if(enable_stick){
		  //Keep track of last scroll
			var lastScroll = 0;
			var header = jQuery(".header-content");
			var body_content = jQuery("#body-content");
			var distance_top = jQuery(".header-content").data('distance-top');

			jQuery(window).scroll(function() {
				//Sets the current scroll position
				var st = jQuery(this).scrollTop();
				//Determines up-or-down scrolling
				if (st > lastScroll) {
					
					//Replace this with your function call for downward-scrolling
					if (st > distance_top ) {
						header.addClass("header-fixed");
						body_content.addClass("has-header-fixed");
					}
				}
				else {
					//Replace this with your function call for upward-scrolling
					if (st < distance_top) {
						header.removeClass("header-fixed");
						body_content.removeClass("has-header-fixed");
					}
				}
				//Updates scroll position
				lastScroll = st;
			});
		}

	}
	
	,toTopButton : function(){
		var to_top_btn = $("#scroll-to-top");
		if( 1 > to_top_btn.length ){
			return;
		}
		$(window).on( 'scroll' , function() {
			var b = jQuery(this).scrollTop();
			var c = jQuery(this).height();
			if (b > 100) { 
				var d = b + c / 2;
			}
			else { 
				var d = 1 ;
			}

			if (d < 1000 && d < c) { 
				jQuery("#scroll-to-top").removeClass('on off').addClass('off'); 
			} else {
				jQuery("#scroll-to-top").removeClass('on off').addClass('on'); 
			}
		});

		to_top_btn.on( 'click',function (e) {
			e.preventDefault();
			jQuery('body,html').animate({scrollTop:0},800,'swing');
		});
	}

	,mailchipPopup : function(){
		var _expire 			= jQuery("#mailchimp-popup").data('expires')
			,_close_popup 		= jQuery("#hideforever_bc_newsletter");


		if ( jQuery.cookie('no_newsletter') ) {
			//it hasn't been one days yet
		} else {
			setTimeout(function(){
				jQuery.fancybox(
					jQuery('#mailchimp-popup'),
					{
						'autoDimensions': false
						,'width'		: 550
						,'autoSize' 	: false
						,'transitionIn'	: 'none'
						,'transitionOut': 'none'
						,'beforeClose'		: function(){
							if( _close_popup.length > 0 &&  _close_popup.prop('checked') ){
								jQuery.cookie('no_newsletter', 'true', { expires: _expire, path: '/' });
							}
							
							//Close Css3 Effect
							$('#mailchimp-popup').parents('.fancybox-wrap').removeClass('zoomIn').addClass('zoomOut');
							//Clear Hover Effect		
							AT_Main.newsletterHoverEffectClear();	
							
	           		 	}
	           		 	,'afterShow'		: function(){
	           		 		
							//Show Css3 Effect
							$('#mailchimp-popup').parents('.fancybox-wrap').addClass('zoomIn animated');
							//Hover Effect		
							AT_Main.newsletterHoverEffect();
							
	           		 	}

					}
				);
			},1000);
			
		}

		
	}
  
  	,effectNavigation : function(){ // Make hover effect of navigation
		jQuery(".navigation .navbar-collapse .main-nav>li").hover(function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass("fadeInUp animated");
		});      	
	}

	,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
		var windowW = jQuery(window).width();
		jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
	}

	,fixReturnScroll : function() {
		jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', ''); 
	}

  	,fixButton : function(){
      	jQuery(".product-wrapper .product-head").each(function(e){
            if($(this).children().hasClass('wrapper-countdown')){
              	$(this).find('.product-button').addClass('fix');
            }
  		});
    }
  
  	,handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
    }
    
	,menuOnMobile : function(){
		jQuery(document).on('click','#page-body',function(e){
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("menu-opened");
			AT_Main.fixReturnScroll();
		});

		jQuery('.menu-mobile .close').on('click', function(e){
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("menu-opened");
			AT_Main.fixReturnScroll();
		});

		jQuery(document).on('click','[data-toggle=offcanvas]',function(e){
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery(".menu-mobile").toggleClass("opened");
			jQuery("html,body").toggleClass("menu-opened")
		});

		jQuery(".navbar .main-nav li > .dropdown-link").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});


		jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(){
			var e=jQuery(this).parents(".dropdown").first();
            if (e.hasClass("menu-mobile-open")) {
                e.removeClass("menu-mobile-open")
            } else {
                e.addClass("menu-mobile-open")
            }
		})

	}
  
  	,callbackSearchMobile : function(){
        var r = $("#search-popup");

        jQuery(".mobile-version .mobile-search").on("click", function(e){
          	r.addClass("active");
        });
      	jQuery("#search-popup .close-search").on("click", function(e){
          	r.removeClass("active")
        });
    }
	
	,handleMenuMultiLine : function() {
		var outItem = "";
		var down = false;

		var top = 0;

		jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
			var target = jQuery(e.currentTarget);

			if( down && outItem != "") {
				outItem.addClass("hold");
				setTimeout(function(){
					if(outItem != "")
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				},500);

				if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
				{       
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				}
			}
			else {
				outItem = "";
			}

		});

		jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

			var target = jQuery(e.currentTarget);

			if( e.pageY >= target.offset().top + 50 ) { //move down
				down = true;
			}

			if( target.hasClass("dropdown") ) { //target has child

				if(outItem == "")
					outItem = target;
			}

		});
	}


	,toggleSearchPopUp : function(){
		/***Make sure user enable search function***/
		if( typeof _bc_config === "undefined" || _bc_config.show_search == "false" ){
			return;	
		}
		if( _bc_config.enable_ajax_search == "true" ){
			//do ajax search here	
		}

		/*jQuery(document).on('click','.searchbox',function(e){
			//e.stopPropagation();  
			jQuery.fancybox(
				jQuery('#product-search'),{
					'width'			: "80%"
					,'height'		: "80%"
					,'openEffect '	: 'fade'
					// ,'transitionOut': 'none'

				}
			);


		});*/

/*		jQuery(document).on('click','#page-body',function(){
			jQuery('.search-sb').removeClass('opened');
			jQuery('html,body').removeClass('search-opened');
			AT_Main.fixReturnScroll();
		});*/
	}

	,toggleCartSidebar : function(){
		jQuery('.cart-toggle').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.cart-sb').toggleClass('opened');
			jQuery('body').toggleClass('cart-opened');
		});

		jQuery('#page-body').on('click',function () {
			jQuery('.cart-sb').removeClass('opened');
			jQuery('html,body').removeClass('cart-opened');
			AT_Main.fixReturnScroll();
		});
	}

	,toggleFilterSidebar : function(){
		jQuery(document).on('click', '.filter-toggle', function(e) {
            e.stopPropagation();
            AT_Main.fixNoScroll();
            jQuery('.sbw-filter').toggleClass('opened');
            jQuery('html,body').toggleClass('filter-opened');
		});

		jQuery(document).on('click', '#page-body', function(e) {
          	
            if( !$(e.target).parents('.sbw-filter').length && !$(e.target).hasClass('sbw-filter') ) {
              	
            	jQuery('.sbw-filter').removeClass('opened');
            	jQuery('html,body').removeClass('filter-opened');
            }
            
		});
	}

	,notifyWishlistProduct : function($w){
		$('.loading').hide();
		$('.button.add-to-wishlist.wl-add').removeClass('disabled');
		$.jGrowl($w,{
			life: 3000
		}); 
	}

	,wishlistProduct : function() {
		$(document).on('click','#product-info button.add-to-wishlist.wl-add',function(e){

			$('.loading').show();

			var $this = $(this)
				,form = $(this).parent('form')
				,i = form.parents(".page-product");

			//console.log(form);

			$this.addClass('disabled');
			e.preventDefault();

			$.ajax({
				type: "POST",
				url: "/contact",
				data: form.serialize(),
				beforeSend: function() {
				  //to do
				},
				success: function(n) {

					var img = i.find("#product-featured-image").attr("src")
						,title = i.find("#product-info h1").text()
						,_wishlist_count = parseInt( jQuery.trim( jQuery(".wishlish-icon").children(".number").html() ) );
						console.log(_wishlist_count);
						if( isNaN( _wishlist_count ) ){
							_wishlist_count = 0;
						}
						//console.log(_wishlist_count);
						_wishlist_count = _wishlist_count + 1 ;
					form.html('<a class="add-to-wishlist" href="'+ _bc_config.wishlist_page_url +'" title="Go to wishlist">Browse Wishlist</a>');
					var $w = '<div class="effect-item row"><div class="col-sm-3 col-xs-3"><img src="'+ img +'" alt="" /></div><div class="col-sm-9 col-xs-9"><p class="effect-item-info">' + title + ' is added to your wish list.</p></div></div>';
					AT_Main.notifyWishlistProduct($w);
					jQuery(".wishlist-icon").each(function( _index,_value ){
						jQuery(_value).children(".number").html( _wishlist_count );
					});
				},
				error: function() {
					// to do
				}
			})
		})
	}
  	
  	,wishlistProductItem : function() {
		$(document).on('click','.product-button button.add-to-wishlist.wl-add',function(e){

			$('.loading').show();

			var $this = $(this);
			$this.addClass('disabled');

			e.preventDefault();
			var form = $(this).parent('form');
			var i = form.parents(".product-wrapper");
			$.ajax({
				type: "POST",
				url: "/contact",
				data: form.serialize(),
				beforeSend: function() {
				  //to do
				},
				success: function(n) {

					var img = i.find(".featured-image").attr("src");
					var title = i.find(".product-name a").text();
					form.html('<a class="add-to-wishlist" href="'+ _bc_config.wishlist_page_url +'" title="Browse Wishlist"><span class="icon icon-wishlist">Browse Wishlist</span></a>');
					var $w = '<div class="effect-item row"><div class="col-sm-3 col-xs-3"><img src="'+ img +'" alt="" /></div><div class="col-sm-9 col-xs-9"><p class="effect-item-info">' + title + ' is added to your wish list.</p></div></div>';
					AT_Main.notifyWishlistProduct($w);
					jQuery(".wishlist-icon").each(function( _index,_value ){
						jQuery(_value).children(".number").html( _wishlist_count );
					});
				},
				error: function() {
					// to do
				}
			})
		})
	}
	
	,handleMap : function(){
		if(jQuery().gMap){
			
			if(jQuery('#page-contact-map').length){ // GMap in contact page
				jQuery('#page-contact-map').gMap({
					zoom: 15
					,scrollwheel: false
					,maptype: 'ROADMAP'
					,address: '21123 Nordhoff St Chatsworth California 91311'
				});
			}
		}	
	}
	
	,dropdownFilter : function(){ // Show,hide advanced-filters in catalog page
		jQuery(document).on('click','.sb-filter .sb-title',function(e){
			e.stopPropagation();
			jQuery(this).toggleClass('none-active');
			jQuery(this).closest('.sb-filter').find('.advanced-filters').toggleClass('hide');
		});
	}
	
	,fixTitle : function(){ // fix title a in filter
		jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
		jQuery(".rt a").removeAttr("title");
	}
	,fixDropdown : function(){
		if(AT_Main.checkLayout() == 1){
			jQuery('.widget-footer .list-unstyled').addClass('dropdown-menu');
			jQuery('.sb-title').addClass('none-active');
			jQuery('.sb-filter').find('.advanced-filters').addClass('hide');
		}
      	jQuery(document).on('click','.profile .icon-user',function(e){
            $(this).parents().find('.profile').toggleClass('open');
  		});
      	jQuery(document).on('click','.currency-block',function(e){
          $(this).toggleClass('open');
        });
	}

	,filterCatalogReplace : function(){
		var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
		var val = value.substring(value.lastIndexOf('?')); 

		collectionUrl = collectionUrl.replace(value, '');

		value = value.replace(val, '');
		value = value.replace('#', '');

		var value_arr = value.split('+');

		var current_arr = [];
		jQuery('#'+filter_id+' li.active-filter').each( function() {
		  current_arr.push(jQuery(this).attr('data-handle'));
		});

		jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
		jQuery('#'+filter_id+' li').removeClass('active-filter');

		for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
		  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
		}

		var new_data = value_arr.join('+')

		var new_url = collectionUrl+new_data+val;

		if( typeof AT_Filter != 'undefined' && AT_Filter ){
			AT_Filter.updateURL = true;
            AT_Filter.requestPage(new_url);		
		}else{
			window.location = new_url;
		}
		
	}
  
	,filterCatalog : function(){
		var currentTags = ''
			,filters 	= jQuery('.advanced-filter');

		filters.each(function() {
			var el = jQuery(this)
				,group = el.data('group');

			if ( el.hasClass('active-filter') ) { //Remove class hidden
				el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
			}
		});

		filters.on('click', function() {
			var el 		= jQuery(this)
				,group 	= el.data('group')
				,url 	= el.find('a').attr('href');

			// Continue as normal if we're clicking on the active link
			if ( el.hasClass('active-filter') ) {
				return;
			}
		});

		jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear

			var filter_id = jQuery(this).attr('id');
			filter_id = filter_id.replace('clear-', '');

			var collectionUrl = window.location.href;

			if(collectionUrl.match(/\?/)){
				var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

				if(string.match(/\//)){
					var str_replace = string.replace(/\//, '');
					collectionUrl = collectionUrl.replace(string, '');
					collectionUrl = collectionUrl+str_replace;
					AT_Main.filterCatalogReplace();
				}
				else{
					AT_Main.filterCatalogReplace();
				}
			}
			else{
				var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);

				collectionUrl = collectionUrl.replace(value, '');  

				value = value.replace('#', '');

				var value_arr = value.split('+');

				var current_arr = [];
				jQuery('#'+filter_id+' li.active-filter').each( function() {
				  current_arr.push(jQuery(this).attr('data-handle'));
				});

				jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
				jQuery('#'+filter_id+' li').removeClass('active-filter');

				for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
				  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
				}

				var new_data = value_arr.join('+')

				var new_url = collectionUrl+new_data;

				if( typeof AT_Filter != 'undefined' && AT_Filter ){
					AT_Filter.updateURL = true;
		            AT_Filter.requestPage(new_url);		
				}else{
					window.location = new_url;
				}
			}

		});
	}
	
	,swatch : function(){
        jQuery('.swatch :radio').change(function() {
          	var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          	var optionValue = jQuery(this).val();
          	jQuery(this)
          	.closest('form')
          	.find('.single-option-selector')
          	.eq(optionIndex)
          	.val(optionValue)
          	.trigger('change');
        });
  	}

	,refreshImage : function(){ // Update product image in detail page
		if(jQuery('#gallery-image').length){

			jQuery('#product-image').on('click', '.thumb-img', function() {

				var jQuerythis = jQuery(this);

				if(!jQuerythis.hasClass('active')){
					var parent = jQuerythis.parents('.product-image-inner');
					var src_original = jQuerythis.attr('data-zoom-image');
					var src_display = jQuerythis.attr('data-image');

					parent.find('.thumb-img').removeClass('active');
					jQuerythis.addClass('active');

					parent.find('.featured-image').find('img').attr('data-zoom-image', src_original);
                 	parent.find('.featured-image').find('img').attr('src', src_display);
				}

				return false;
			});
		}
	}

	,refreshZoom : function(){ // Update Zoom in detail page
		var enable_zoom = jQuery('.featured-image').data('zoom');
		if((jQuery('.elevatezoom').length)){

			var zoomImage = jQuery('.elevatezoom .zoom-image');

			zoomImage.elevateZoom({
				gallery				:'gallery-image' 
				,galleryActiveClass	: 'active'
				,zoomType			: 'lens'
				,cursor				: 'pointer'
				,lensShape 			: "round"
				,lensSize 			: 300
			});

			//pass the images to Fancybox
			jQuery(".elevatezoom").bind("click", function(e) {  
				var ez =   jQuery('.elevatezoom .zoom-image').data('elevateZoom'); 
				jQuery.fancybox(ez.getGalleryList(),{
					closeBtn  : false,
					helpers : {
						buttons : {}
					}
				});
				return false;
			});
		}

	}
  
    ,mobileDetect : function(){
          var md = new MobileDetect(window.navigator.userAgent);

              if(md.mobile() == null) {//not on phone and tablet
                  new WOW().init();   
              }

      }

	,cartJS_handle : function() {
		//Bind cart json data to HTML
		rivets.bind(jQuery('.templateCart #cartform, .cart-right, .page-cart .cart-empty-wrapper, #cart-content'), {cart: CartJS.cart});
		//It's need to calculate from default currency to current currency that has chosen before 
      	
		//Handle when update to cart json completed
		jQuery(document).on('cart.requestComplete', function(event, cart) {
			Shopify.onCartUpdate(CartJS.cart);
          	                    
		});
	}

	,instagram_listener : function(){
		if( jQuery('#instagram_list').length > 0 ){
		  
			if( 'undefined' === typeof Instafeed ){
				console.log(" Instafeed has not defined yet! ");
				return;
			}
		  
			var instar_feed;
			jQuery('#instagram_list').each(function( index,value ){
				instar_feed = new Instafeed({
					get: "user"
					,target		: "instagram_list"
					,accessToken	: jQuery(value).data('token-key')
					,userId		: jQuery(value).data('uid')
					//,clientId	: $(value).data('cid')
					,limit		: jQuery(value).data('limit')
                    ,resolution : "low_resolution"
                    ,resolution2 : "standard_resolution"
					,after: function() {
						jQuery("#instagram_list > a").each(function(index,value){
                          	jQuery(value).addClass('item');
                          	jQuery(value).attr("target","_blank");
                  			var key = index + 1;
                  			if( key == 1 || key == 8 ){
                  				jQuery(value).addClass('double-size');
                              	var db_size_src = jQuery(value).attr('rel');
                                jQuery(value).children('img').attr('src',db_size_src);
                			}
						});
                      
                      	
					}
			});
			instar_feed.run();
		  });
		  
		}
		if( jQuery('#instagram_list_widget').length > 0 ){
		  
			if( 'undefined' === typeof Instafeed ){
				console.log(" Instafeed has not defined yet! ");
				return;
			}
		  
			var instagram_list_widget;
			jQuery('#instagram_list_widget').each(function( index,value ){
				instagram_list_widget = new Instafeed({
					get: "user"
					,target		: "instagram_list_widget"
					,accessToken	: jQuery(value).data('token-key')
					,userId		: jQuery(value).data('uid')
					//,clientId	: $(value).data('cid')
					,limit		: jQuery(value).data('limit')
                    ,resolution : "low_resolution"
                    ,resolution2 : "standard_resolution"
			});
			instagram_list_widget.run();
		  });
		  
		}		
	}  

	,lookbooks_initor : function(){ 
		if( jQuery('.bc-lookbooks.lookbooks.margin-row').length > 0 ){
		  
			if( 'undefined' === typeof Isotope ){
				console.log(" Isotope has not defined yet! ");
				return;
			}

			jQuery('.bc-lookbooks.lookbooks.margin-row').isotope({
			  itemSelector: '.look-item',
			  layoutMode: 'fitRows'
			});
		}
		if( jQuery('.bc-lookbooks.lookbooks.look-slider').length > 0 ){
		  
			if( 'undefined' === typeof Swiper ){
				console.log(" Swiper has not defined yet! ");
				return;
			}
          
          	$('body').addClass('carousel-lookbook');

            var swiper_look = new Swiper('.lookbooks-wrapper.look-slider', {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows : true
                },
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev', 
                pagination: '.swiper-pagination',
                paginationType: 'progress',
                slidesPerView: 'auto',
                paginationClickable: true,
              	initialSlide: Math.floor(jQuery('.bc-lookbooks.lookbooks.look-slider .look-item').length / 2),
                spaceBetween: 30
            });
		}      
	}

  	,callPriceSlider: function() {
      if( jQuery('#range-slider').length < 1 ){
        	return;
      }
      jQuery('#range-slider').slider({
        range: true,
        min: 10,
        max: 1000,
        values: [10, 1000],
        create: function() {
          jQuery("#amount").html("$10 - $1000");
        },
        slide: function (event, ui) {
          jQuery("#amount").html("$" + ui.values[0] + " - $" + ui.values[1]);
          var mi = ui.values[0];
          var mx = ui.values[1];
          filterSystem(mi, mx);
        }
      })


      function filterSystem(minPrice, maxPrice) {
        jQuery(".cata-product .product-price-range").hide().filter(function () {
          var price = parseInt($(this).data("price"), 10);
          return price >= minPrice && price <= maxPrice;
        }).show();
      }

    }    
    ,switchCollectionMode : function(){
    	if( !jQuery('body').hasClass('templateCollection') ){
    		//console.log('not collection page');
    		return;
    	}    	
	    jQuery(document).on('click', ".collection-toolbar .grid-list span.mode-switcher", function(e){   
	    	if( !jQuery(this).hasClass('active') ){
	    		var _new_mode 	= jQuery(this).hasClass('grid') ? "grid" : "list"
	    			,_old_mode 	= _new_mode == "list" ? "grid" : "list" ;  	
	    		jQuery(".collection-toolbar .grid-list span.mode-switcher").removeClass('active');
	    		jQuery(this).addClass('active');
	    		jQuery.cookie('bc_collection_mode', _new_mode, { expires: 90, path: '/', domain: window.location.hostname });
	    		
	    		jQuery('.collection-product').removeClass( 'mode-'+_old_mode ).addClass( 'mode-'+_new_mode );
	    		jQuery('.collection-product .product-item').removeClass( 'product-' + _old_mode + '-item' ).addClass( 'product-' + _new_mode + '-item' );
	    	}    
	    });

	    jQuery( document ).on('ajaxComplete', function( event, xhr, settings ) {
	    	jQuery( document ).trigger('bc_load_ready');
		});

	    jQuery( document ).on('bc_load_ready', function() {
	    	//console.log('bc_load_ready fired');
	    	var _store_mode = jQuery.cookie('bc_collection_mode');
			if ( typeof _store_mode != 'undefined' && _store_mode !== null && _store_mode.length > 0 ) {
				if( jQuery(".collection-toolbar .grid-list span.mode-switcher.active").hasClass(_store_mode) ){
					return;
				}else{
					jQuery(".collection-toolbar .grid-list span.mode-switcher").removeClass('active');
					jQuery(".collection-toolbar .grid-list span.mode-switcher." + _store_mode ).addClass('active');
		    		var _new_mode 	= _store_mode
		    			,_old_mode 	= _new_mode == "list" ? "grid" : "list" ;
		    		jQuery('.collection-product').removeClass( 'mode-'+_old_mode ).addClass( 'mode-'+_new_mode );
		    		jQuery('.collection-product .product-item').removeClass( 'product-' + _old_mode + '-item' ).addClass( 'product-' + _new_mode + '-item' );
				}
			}
		});
	    jQuery( document ).trigger('bc_load_ready');

	    
    }

    ,imagePlaceHolder : function(e) {
      	var slideLen = $('#home-slideshow .swiper-slide').length,
            count = 0;
    	$('img[data-hold]').each(function(){
    		var src = $(this).attr('data-hold'),
    			img = new Image(),
    			$this = $(this);
    		img.onload = function(e){
    			$this.attr('src', src);
              	if($this.parents('#home-slideshow').length) {
                  	count++
                    if(count == slideLen) {
                    	if ( bcMsieVersion.MsieVersion() == 0 ){
                          AT_Main.homeSlideshow();
                        }

                        else{
                          if ( bcMsieVersion.MsieVersion() > 9 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
                            AT_Main.homeIE();
                          }
                          else{
                            jQuery('#home-slideshow').owlCarousel({
                              nav			: true
                              ,dots 		: true
                              ,items		: 1
                              ,navText	: ['<i class="fa fa-arrow-left" title="previous"></i>', '<i class="fa fa-arrow-right" title="Next"></i>']
                            })
                          }
                        }
                    }
              	}	
    		};
    		img.src = src;
    		
    	});
    }
          
    ,switchImgProduct: function() {
    	$('.product-wrapper .swatch-element > input').on('change', function(e){
          	e.stopPropagation();
          	var imgUrl = $(this).data("swatch-image"),
                parent = $(this).parents('.product-wrapper'),
                imgElem = parent.find('.product-image img');
          	imgElem.parents('.product-image').addClass('img-loading');
          	imgElem.attr('src', imgUrl)
          	var fakeImg = new Image();
          	fakeImg.src = imgUrl;
            fakeImg.onload = function(event){
                imgElem.parents('.product-image').removeClass('img-loading');
            };
            fakeImg.onerror = function() {
                //Code for error loading
            };
        });
    }
          
	,init : function(){
		this.imagePlaceHolder();
      	this.previewPanel();
      	this.setBkgHeaderCatalog();
      	this.initCounter();
      	this.initFAQ();
      	this.initBackStretch();
      	this.initProgressBarVertical();
		this.stickMenu();
		this.toTopButton();
        this.fixButton();
		this.menuOnMobile();
        this.callbackSearchMobile();
		this.handleMenuMultiLine();
		this.toggleSearchPopUp();
		this.toggleCartSidebar();
		this.toggleFilterSidebar();
		this.wishlistProduct();
        this.wishlistProductItem();
		this.handleMap();
		this.dropdownFilter();
		this.fixTitle();
		this.fixDropdown();
		this.filterCatalog();
        this.swatch();
		this.refreshImage();
		this.refreshZoom();
		this.cartJS_handle();
		this.instagram_listener();
        this.switchCollectionMode();
      	this.switchImgProduct();
	}
}


/* Handle when window resize */
jQuery(window).resize(function() {
	//console.log('resize');
	/* reset menu with condition */
	if(AT_Main.getWidthBrowser() < 1024){
		if(jQuery('#top').hasClass('on')){
			jQuery('#top').prev().remove();
			jQuery('#top').removeClass('on').removeClass('animated');
		}
	}

	/*Reset Page when fixNoScroll had called before*/
	AT_Main.fixReturnScroll();
	if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened'))
		jQuery("#page-body").trigger('click');
	if(AT_Main.checkLayout() != 1 && jQuery('#sidebar .sbw-filter').hasClass('opened'))
		jQuery("#page-body").trigger('click');

	/*Re-init 3d hover effect off newsletter*/
	
	if( $('#mailchimp-popup').is(":visible") ) {
		AT_Main.newsletterHoverEffectClear();
		AT_Main.newsletterHoverEffect();	
	}
	
          
});
      
$(window).load(function() {
  	if (!$('html').is('.ie6, .ie7, .ie8'))
	{		
		$("#site-loader").delay(1000).fadeOut("slow");
		AT_Main.mailchipPopup();
	}
	else
	{
		$("#site-loader").css('display','none');
		AT_Main.mailchipPopup();
	}

    if( jQuery('#instagram_list').length > 0 ){
        
      setTimeout(function(){
        jQuery('#instagram_list').imagesLoaded( function() {
          //images have loaded
          jQuery('#instagram_list').isotope({
            // options
            itemSelector: '.item',
            layoutMode: 'masonry',
            percentPosition: true,
            masonry: {
              // use outer width of grid-sizer for columnWidth
              columnWidth: '.item:not(.double-size)'
            }
          });

        });
      },50);

      $(window).on('resize',function(){
        jQuery('#instagram_list').isotope('destroy');
        setTimeout(function(){
          jQuery('#instagram_list').isotope({
            // options
            itemSelector: '.item',
            layoutMode: 'masonry',
            percentPosition: true,
            masonry: {
              // use outer width of grid-sizer for columnWidth
              columnWidth: '.item:not(.double-size)'
            }
          });
        },500)

      }); 
    }  

});
      
jQuery(document).ready(function($) {
	AT_Main.init();
});

jQuery(window).on('load', function(){
	AT_Main.lookbooks_initor();
});